var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentCategory && _vm.currentCategory.children
    ? _c("div", { staticClass: "category__sub-cats" }, [
        _c("div", { staticClass: "swiper-container" }, [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.currentCategory.children, function(category) {
              return category.details
                ? _c("div", { staticClass: "swiper-slide" }, [
                    _c("a", { attrs: { href: category.url } }, [
                      _c("div", { staticClass: "swiper-slide-img" }, [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: "/documents/" + category.details[0].image2Path,
                            alt: category.details[0].name
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "swiper-slide-text" }, [
                        _vm._v(_vm._s(category.details[0].name))
                      ])
                    ])
                  ])
                : _vm._e()
            }),
            0
          )
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1)
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-button-next" }, [
      _c("i", { staticClass: "fa fa-chevron-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-button-prev" }, [
      _c("i", { staticClass: "fa fa-chevron-left" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }